import React from 'react';
import {Grid} from '@mui/material';
import {Box} from '@mui/system';
import {useGetEmployees} from './invitationQueries';
import AutoField, {ActionType} from '../../components/AutoForm/AutoFieldNew';

import {useAutoField} from '../../components/AutoForm/useAutoForm';
import {ContactATRECQStatusEnum} from '../../schema-types/globalTypes';
import {enumToLabel} from '../../utils/typescriptUtils';

export const InvitationFilters: React.FC<{
  includeATR?: boolean;
  includeECQ?: boolean;
}> = ({includeATR, includeECQ}) => {
  const {employees} = useGetEmployees();
  const [{value: searchValue}, _, {setValue: setSearchValue}] = useAutoField('search');

  const atrEcqOptions: {value: ContactATRECQStatusEnum | 'ALL'; label: string}[] =
    Object.values(ContactATRECQStatusEnum).map((x) => ({
      value: x,
      label: enumToLabel(x.toLocaleLowerCase()),
    }));
  atrEcqOptions.push({value: 'ALL', label: 'All'});

  return (
    <Grid item xs={12} mb={2} bgcolor="white" borderRadius={4} sx={{mt: 3, p: 2}}>
      <Grid container spacing={4}>
        <Grid position="relative" item xs={6} sm={3} md={3} lg={4}>
          <Box position="relative">
            <AutoField
              field={{
                type: ActionType.text,
                id: 'search',
                label: 'Search accounts...',
                fullWidth: true,
                showClearButton: true,
                canBeEmpty: true,
              }}
            />
          </Box>
        </Grid>

        <Grid item xs={6} sm={3} md={3} lg={2}>
          <AutoField
            field={{
              type: ActionType.selectAutocomplete,
              id: 'staff',
              label: 'Owner',
              canBeEmpty: true,
              options: [
                {value: 'ALL', label: 'All staff'},
                ...employees.map((employee) => ({
                  value: employee.id,
                  label: `${employee.firstName} ${employee.lastName}`,
                })),
              ],
              fullWidth: true,
            }}
          />
        </Grid>
        {includeATR && (
          <Grid item xs={6} sm={3} md={3} lg={2}>
            <AutoField
              field={{
                type: ActionType.select,
                id: 'atrStatus',
                label: 'RTQ Status',
                canBeEmpty: true,
                options: atrEcqOptions,
                fullWidth: true,
              }}
            />
          </Grid>
        )}

        {includeECQ && (
          <Grid item xs={6} sm={3} md={3} lg={2}>
            <AutoField
              field={{
                type: ActionType.select,
                id: 'ecqStatus',
                label: 'ECQ Status',
                canBeEmpty: true,
                options: atrEcqOptions,
                fullWidth: true,
              }}
            />
          </Grid>
        )}
      </Grid>
    </Grid>
  );
};
